import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.timekeeping')
  .factory('$attendance', attendanceArrayFactory);

/* @ngInject */
function attendanceArrayFactory($bringozFactory: $bringozFactory,
                                AttendanceAPI: BringozApi) {

  function $attendance(agentId?: string) {
    return $bringozFactory(agentId, AttendanceAPI);
  }

  return $attendance;
}
